/**
 * Wait until images under `root` have loaded or failed, so print/PDF can include them.
 * @param {ParentNode | null | undefined} root
 * @param {{ timeoutMs?: number }} [options]
 */
export function waitForElementImages(root, { timeoutMs = 4000 } = {}) {
  const images = root ? [...root.querySelectorAll("img")] : [];
  if (!images.length) {
    return Promise.resolve();
  }

  const pending = images.map((image) => {
    if (image.complete) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      image.addEventListener("load", resolve, { once: true });
      image.addEventListener("error", resolve, { once: true });
    });
  });

  return Promise.race([
    Promise.all(pending),
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}
